(ns app.zap-vault.vault.model)

(def root-path [::state])

(def collapsed?-key :collapsed)
(def collapsed?-full-path (into root-path [collapsed?-key]))

(def selected-file-id-key :selected-file-id)
(def selected-file-id-full-path (into root-path [selected-file-id-key]))
